module.exports = __webpack_public_path__ + "public/img/Poster Siap Kerja dengan Kartu Prakerja.9302931d.png";